import React from "react";
import { WrapStyle } from "./styles";

export interface DocLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  noBorderTop?: boolean;
}

const CreateDocumentClassFormBody = ({
  noBorderTop,
  children,
  ...rest
}: DocLayoutProps) => {
  return (
    <WrapStyle noBorderTop={noBorderTop} {...rest}>
      {children}
    </WrapStyle>
  );
};

export default CreateDocumentClassFormBody;
